import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Upload } from 'lucide-react';
import { postResume } from '../services/api';
import toast from 'react-hot-toast';

export default function PostResume() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', designation: '', experience: '', skills: '' });
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const fileRef = useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone || !file) {
      toast.error('Please fill all required fields and upload your resume');
      return;
    }
    setSubmitting(true);
    const data = new FormData();
    Object.entries(form).forEach(([k, v]) => data.append(k, v));
    data.append('resume', file);
    try {
      await postResume(data);
      toast.success('Resume posted successfully!');
      setForm({ name: '', email: '', phone: '', designation: '', experience: '', skills: '' });
      setFile(null);
    } catch {
      toast.error('Failed to post resume');
    }
    setSubmitting(false);
  };

  return (
    <>
      <div className="page-header">
        <h1>Post Your Resume</h1>
        <p>Upload your resume and let employers find you</p>
        <div className="breadcrumb">
          <Link to="/">Home</Link> / <span>Post Resume</span>
        </div>
      </div>
      <div className="form-page">
        <div className="form-card">
          <h2>Submit Your Resume</h2>
          <p className="subtitle">Fill in your details and upload your resume to get noticed by top recruiters.</p>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Full Name *</label>
                <input type="text" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} required />
              </div>
              <div className="form-group">
                <label>Email *</label>
                <input type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} required />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Phone *</label>
                <input type="tel" value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})} required />
              </div>
              <div className="form-group">
                <label>Designation</label>
                <input type="text" placeholder="e.g. Software Engineer" value={form.designation}
                  onChange={(e) => setForm({...form, designation: e.target.value})} />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Experience</label>
                <select value={form.experience} onChange={(e) => setForm({...form, experience: e.target.value})}>
                  <option value="">Select experience</option>
                  <option>Fresher</option>
                  <option>1-2 Years</option>
                  <option>2-4 Years</option>
                  <option>4-6 Years</option>
                  <option>6-10 Years</option>
                  <option>10+ Years</option>
                </select>
              </div>
              <div className="form-group">
                <label>Key Skills</label>
                <input type="text" placeholder="e.g. React, Node.js, Python" value={form.skills}
                  onChange={(e) => setForm({...form, skills: e.target.value})} />
              </div>
            </div>
            <div className="form-group">
              <label>Upload Resume *</label>
              <div className="file-upload" onClick={() => fileRef.current.click()}>
                <Upload size={36} color="#94a3b8" />
                <p>Click to upload your resume (PDF, DOC, DOCX — Max 5MB)</p>
                {file && <div className="file-name">{file.name}</div>}
                <input type="file" ref={fileRef} accept=".pdf,.doc,.docx"
                  onChange={(e) => setFile(e.target.files[0])} />
              </div>
            </div>
            <button type="submit" className="btn-submit" disabled={submitting}>
              {submitting ? 'Submitting...' : 'Post Resume'}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
